import { useFeature } from 'src/app/FeatureToggle/useFeature';

import { DefaultTripAddressField } from './DefaultTripAddressField';
import { PayerAuthorizedDriverSettings } from './PayerAuthorizedDriverSettings';
import { PayerAuthorizedVehicleSettings } from './PayerAuthorizedVehicleSettings';
import { PayerMultiLoadSettings } from './PayerMultiLoadSettings';
import { PayerNoteSettings } from './PayerNoteSettings';
import { PayerPickupDropoffTimeSettings } from './PayerPickupDropoffTimeSettings';
import { PayerSignatureSettings } from './PayerSignatureSettings';
import { PayerTripRequiredFieldSettings } from './PayerTripRequiredFieldSettings/PayerTripRequiredFieldSettings';

export const PayerSpecificSettings = () => {
  const { isEnabled: isPayerAllowedVehiclesAndDriversEnabled } = useFeature(
    'payer allowed vehicles and drivers'
  );
  const { isEnabled: isTripRequiredFieldsEnabled } = useFeature(
    'trip required fields'
  );

  return (
    <>
      <DefaultTripAddressField />
      <div className="pt-4">
        <div className="flex flex-col gap-3 divide-y divide-gray-200">
          <PayerMultiLoadSettings />
          {isPayerAllowedVehiclesAndDriversEnabled && (
            <>
              <PayerAuthorizedDriverSettings />
              <PayerAuthorizedVehicleSettings />
            </>
          )}
          <PayerSignatureSettings />
          {isTripRequiredFieldsEnabled && <PayerTripRequiredFieldSettings />}
          <PayerPickupDropoffTimeSettings />
          <PayerNoteSettings />
        </div>
      </div>
    </>
  );
};
